import { Div } from '../../../../base/components/native/div'
import { Img } from '../../../../base/components/native/img'
import { CENTER, WH } from '../../../../base/helpers/style'

export const AssistantOption = (imagePath: string, title: string, emoji: string = '') => {

    const base = Div()
    const img = Div(emoji)
    const titleDiv = Div(title)
    base.append(img, titleDiv)

    img.cssClass({
        backgroundImage: `url(${imagePath})`,
        backgroundSize: 'cover',
        borderRadius: '10px',
        cursor: 'pointer',
        fontSize: '60px',
        border: '1px solid white',
        ...CENTER,
        ...WH(100),
    })
    titleDiv.cssClass({
        colo: '#222222',
        marginTop: '6px',
        fontsize: '13px'
    })
    base.cssClass({
        marginRight: '10px',
    })

    return base
}